import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router";
import { useInvoice, type InvoiceScope } from "../api/invoices.js";
import { InvoiceDocument } from "../components/InvoiceDocument.js";

/** Shared by both roles — `?scope=supplier` picks the supplier-side read path, restaurant is the default. */
export function InvoicePrintPage() {
  const { id = "" } = useParams();
  const [params] = useSearchParams();
  const scope = (params.get("scope") === "supplier" ? "supplier" : "restaurant") as InvoiceScope;
  const { data: invoice, isPending, error } = useInvoice(scope, id);

  useEffect(() => {
    if (invoice) {
      // Opens the print dialog on the frame after rendering finishes.
      const timer = setTimeout(() => window.print(), 100);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [invoice]);

  if (isPending) return <p className="p-6 text-stone-500">불러오는 중…</p>;
  if (error || !invoice) return <p className="p-6 text-red-600">청구서를 불러오지 못했습니다.</p>;

  return (
    <div className="mx-auto max-w-3xl p-4">
      <InvoiceDocument invoice={invoice} />
      <button
        type="button"
        className="no-print mt-4 rounded-lg border border-stone-300 px-4 py-2"
        onClick={() => window.print()}
      >
        인쇄 / PDF로 저장
      </button>
    </div>
  );
}
